<template>
    <div>
        <div class="mb-3 text-right">
            <hts-form-button
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                @click="openCreate">
                Thêm workspace
            </hts-form-button>
        </div>

        <hts-data-table
            ref="tables"
            :headers="headers"
            :server="apiGetList"
            :auto-size="autoSizeTable" />

        <hts-drawer
            v-model="createVisible"
            :submit="createWorkspace"
            :title="$t('labels.create')"
            :rules="rules">
            <hts-form-input
                v-model="createData.name"
                :label="$t('labels.workspaceName')"
                required
                name="workspaceName"
                prop="workspaceName" />

            <hts-form-select
                v-model="createData.type"
                :label="$t('labels.workspaceType')"
                :items="workspaceTypes"
                key-id="id"
                key-label="label"
                name="workspaceType"
                prop="workspaceType"
                required />

            <hts-form-checkbox
                v-if="createData.type === 'VENDOR'"
                v-model="createData.admincpInitialData"
                :checked="!!createData.admincpInitialData"
                :items="[{ label: 'Khởi tạo dữ liệu mặc định cho AdminCP', value: true }]" />
        </hts-drawer>
    </div>
</template>
<script lang="ts" setup>
const createVisible = ref(false)
const createData = reactive({
  name: '',
  code: '',
  type: '',
  admincpInitialData: false
})
const autoSizeTable = {
  active: false,
  skipHeader: false
}

const tables = ref()

const workspaceTypes = [
  {
    id: 'VENDOR',
    label: 'Nhà xe'
  },
  {
    id: 'IMPORT_AND_EXPORT',
    label: 'Xuất nhập khẩu'
  }
]

const rules = ref({
  workspaceName: 'required',
  workspaceType: 'required'
})
const openCreate = () => {
  createVisible.value = true
}
const createWorkspace = () => {
  $api($urlSystem.workspace.create, { body: createData })
    .then((data) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        process.client && $toast().success($t('labels.addSuccess'))
        createData.code = ''
        createData.name = ''
        createData.type = ''
        createData.admincpInitialData = false

        createVisible.value = false
        refreshTables()
      }
    })
    .catch(() => {
      // createVisible.value = false
    })
}

const refreshTables = () => {
  if (tables.value) {
    tables.value.refresh()
  }
}
const apiGetList = $urlSystem.workspace.getList

const headers = [
  {
    field: 'name',
    headerName: $t('labels.workspaceName'),
    sortable: true,
    filter: 'agTextColumnFilter',
    minWidth: 150
  },
  {
    field: 'code',
    headerName: $t('labels.code'),
    filter: 'agTextColumnFilter',
    sortable: true,
    minWidth: 150
  },
  {
    field: 'type',
    headerName: $t('labels.workspaceType'),
    minWidth: 150,
    valueFormatter: (params: any) => {
      const type = params?.data?.type
      if (type === 'VENDOR') {
        return 'Nhà xe'
      }
      if (type === 'IMPORT_AND_EXPORT') {
        return 'Xuất nhập khẩu'
      }
      return ''
    }
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    minWidth: 180
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    popup: true,
    suppressRowTransform: true,
    suppressMenu: true,
    resizable: false,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: 'Actions',
    cellRendererParams: {
      storeKey: 'businessDataTable',
      storeName: 'Business',
      items: [
        {
          icon: 'hi-pencil-icon',
          label: $t('labels.roles'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermissionAdmin('user_management'),
          click: () => {}
        }
      ]
    }
  }
]
</script>
